import { Container } from "@mui/material";
import baseTiger from "../../assets/base_tiger.png";
import SectionTitle from "../../components/SectionTitle";
import { ABOUT_SECTION } from "../../constants";

const {
  firstParagraph,
  subtitle1,
  secondParagraph,
  subtitle2,
  thirdParagraph,
} = ABOUT_SECTION;
const AboutSection = () => {
  return (
    <section id="about">
      <Container
        sx={{
          whiteSpace: "pre-wrap",
        }}
      >
        <div
          className="tiger-image"
          style={{
            backgroundSize: "contain",
            backgroundImage: `url("${baseTiger}")`,
            margin: "0 auto",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="tiger-shadow"
            style={{
              backgroundImage: `linear-gradient(rgba(131, 58, 180, 0) 0%, rgba(0, 0, 0, 0.5) 70%, rgb(0, 0, 0) 100%), url("${baseTiger}")`,
            }}
          ></div>
        </div>
        <SectionTitle title={"ABOUT"}></SectionTitle>
        <p>{firstParagraph}</p>
        <strong>{subtitle1}</strong>
        <p>{secondParagraph}</p>
        <strong>{subtitle2}</strong>
        <p>{thirdParagraph}</p>
      </Container>
    </section>
  );
};

export default AboutSection;
